import { useEffect, useState } from "react";
import { format, differenceInCalendarDays, differenceInWeeks, getYear } from "date-fns";
import { IRackOutplantingPrediction } from "@/types/data";


function useFormatOutplantingDate(data: IRackOutplantingPrediction | undefined, error: Error | null) {
  const [outplantingDate, setOutplantingDate] = useState<null|string>(null);
  const [description, setDescription] = useState<string>("");

  useEffect(() => {
    if (data && data.outplant_date) {
      if (getYear(data.outplant_date) !== getYear(new Date())) {
        setOutplantingDate(format(data?.outplant_date, "MMM d, yyyy"));
      } else {
        setOutplantingDate(format(data?.outplant_date, "MMM d"));
      }
      const daysToOutplant = differenceInCalendarDays(data.outplant_date, new Date());
      if (daysToOutplant > 100) {
        const weeksToOutplant = differenceInWeeks(data.outplant_date, new Date());
        setDescription(`~${weeksToOutplant} weeks ±${data.uncertainty_range} days confidence`);
      } else {
        setDescription(`~${daysToOutplant} days ±${data.uncertainty_range} days confidence`);
      }
    }

    if (error) {
      setOutplantingDate("");
      setDescription(error.message);
    }

  }, [data, error]);


  return {
    outplantingDate,
    description,
  };
}

export default useFormatOutplantingDate;
